export * from './adapters'
export * from './columns'

export const splitBySpace = (input: string): string[] => {
  const matches = input.match(/\S+/g)
  return matches ?? []
}
